(function () {
  window.opvMerkmale = function (feder, slider) {
    var weg = { montage: feder && slider, slider: !slider, hoehe: !feder, vesa: false };
    document.querySelectorAll('[data-opv-merkmal]').forEach(function (f) { f.hidden = !!weg[f.dataset.opvMerkmal]; });
  };
  function start() {
    var k = document.querySelector('[data-okr]');
    if (!k || k.dataset.okrBereit) return;
    k.dataset.okrBereit = '1';
    var daten = {};
    try { daten = JSON.parse(k.querySelector('[data-okr-daten]').textContent); } catch (e) { daten = { teile: {} }; }
    var feld = k.querySelector('[data-okr-feld]');

    function geschwister() {
      return Array.prototype.filter.call(k.parentElement.children, function (el) { return el !== k && el.tagName !== 'DIALOG'; });
    }
    function modus(m) {
      k.querySelectorAll('[data-okr-r]').forEach(function (b) {
        var an = b.dataset.okrR === m;
        b.classList.toggle('is-an', an);
        b.setAttribute('aria-selected', an ? 'true' : 'false');
      });
      feld.hidden = m !== 'individuell';
      if (m !== 'individuell') {
        document.querySelectorAll('[data-opv-feder]').forEach(function (f) {
          window.opvMerkmale(f.dataset.opvFeder === 'true', f.dataset.opvSlider === 'true');
        });
      }
      k.classList.toggle('is-individuell', m === 'individuell');
      geschwister().forEach(function (el) {
        if (m === 'individuell') {
          if (!el.hidden && el.style.display !== 'none') {
            el.hidden = true; el.dataset.okrVersteckt = '1';
            el.dataset.okrDisplay = el.style.display; el.style.display = 'none';
          }
        } else if (el.dataset.okrVersteckt) {
          el.hidden = false; el.style.display = el.dataset.okrDisplay || '';
          delete el.dataset.okrVersteckt; delete el.dataset.okrDisplay;
        }
      });
    }
    function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
    function zeile(t, empf) {
      var d = (daten.teile || {})[t.sku] || { name: t.sku, bild: '' };
      return '<li>' + (d.bild ? '<img src="' + esc(d.bild) + '" alt="" width="40" height="40" loading="lazy">' : '<span></span>')
        + '<span>' + (t.n > 1 ? t.n + '× ' : '') + esc(d.name)
        + (empf ? ' <span class="okr__empf">' + esc(daten.empfohlen || '') + '</span>' : '') + '</span></li>';
    }

    k.addEventListener('click', function (e) {
      var b = e.target.closest('[data-okr-r]');
      if (b) modus(b.dataset.okrR);
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-okr-oeffnen]')) return;
      modus('individuell');
      var oben = k.getBoundingClientRect().top + window.scrollY - 96;
      if (window.scrollY > oben) window.scrollTo({ top: Math.max(0, oben), behavior: 'smooth' });
    });
    document.addEventListener('one:konfigurieren', function (e) {
      var d = e.detail || {};
      var liste = k.querySelector('[data-okr-teile]');
      liste.innerHTML = (d.teile || []).map(function (t) { return zeile(t, false); }).join('')
        + (d.empfohlen || []).map(function (t) { return zeile(t, true); }).join('');
      k.querySelector('[data-okr-uebernommen]').hidden = true;
      modus('individuell');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
